/**
 * css module
 * @description 支持less. 约定以 .module.css / .module.less 的样式启动css module
 * @see cra v5 之后，支持tailwind.css，建议使用tailwind.css及jss方案，如emotion.
 * @see https://www.tailwindcss.cn/
 * @see https://emotion.sh/docs/introduction
 */

import Merge from "./merge";
import ZdHome from "@/routes/zd/home";
export default function Index() {

    return (
        window.zdvisitLink ? window.location.href.includes("#/zdChat") ? <Merge /> :  <ZdHome /> :
        <Merge />
    )
}
